module.exports = __webpack_public_path__ + "static/media/dp2.59a96cc8.webp";